// localStorage adapter. Synchronous under the hood but exposed as async to match
// the adapter contract (get/set/remove(key)). Only used when hasLocalStorage().

export class LocalAdapter {
  async get(key) { return window.localStorage.getItem(key); }
  async set(key, value) { window.localStorage.setItem(key, value); }
  async remove(key) { window.localStorage.removeItem(key); }
}
